module.exports = __webpack_public_path__ + "static/media/pause.9f30a465.svg";